import { render } from "./ConversationFiles.vue?vue&type=template&id=1f256675&scoped=true"
import script from "./ConversationFiles.vue?vue&type=script&lang=js"
export * from "./ConversationFiles.vue?vue&type=script&lang=js"

import "./ConversationFiles.vue?vue&type=style&index=0&id=1f256675&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f256675"]])

export default __exports__